import React from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { StudentSignUpHeroSection } from '../StudentSignUpHeroSection';
import { StudentSignUpFormSection } from '../StudentSignUpFormSection';
export const StudentSignUp = () => {
  return <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-8047">
      <Navbar data-id="element-8048" />
      <main data-id="element-8049">
        <StudentSignUpHeroSection data-id="element-8050" />
        <StudentSignUpFormSection data-id="element-8051" />
      </main>
      <Footer data-id="element-8052" />
    </div>;
};